// Put your applicaiton javascript here
/* Set the width of the side navigation to 250px */

function humanize(str) {
  var i, frags = str.split('_');
  for (i=0; i<frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(' ');
}
/* is Mobile by Touch */
function isMobileByTouch() {
// Checks if 'ontouchstart' is in the window, 
// which is a good indicator of a touch-enabled device.
return ('ontouchstart' in window) || 
          // Checks for Pointer Events with maxTouchPoints > 0
          (navigator.maxTouchPoints > 0) || 
          // For older IE/Edge
          (navigator.msMaxTouchPoints > 0);
} 
/* is Mobile by Agent */ 
function isMobileByAgent() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Keywords commonly found in mobile user agents
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |mobi|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|un)|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|st)|(am|r)ex|aq(i|s)|as(t|w)|attw|au(di|\-m|r |s )|avan|be(ck|nd)|bi(ll|t)|ca(pt|oo)|cb(k|s)|cwa|cdm|ce(ef|ko)|co(lg|s|v)|cpt |d(ek|on)|da(ho)|dc(3k|fl)|dbte|dc\-s|difi|dica|doug|dP(0|1)d|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(l0|e)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|g9m |ga(ay)|gb(cd)|gc\-m|ge(52|60|70|f0)|gf|gla|gm(l\d)|go(\.w|od)|gr(ad|h)|haie|hcit|hd(m|p|t)|hei|hi(pt|o|v)|hp(i|m)|hth |iato|i(gf|me|mo|wi)|it(al|on|st)|j'wa|jbro|jemu|jigs|kddi|keji|kf|kg(ai|tv)|kta|l2e|lag(0|o)|lgh |li(\W|nd)|log|m\-dc|madi|me(42|a\s|e\s|\-a|o\s|\-v)|mg(50|60|80)|mi(j|o)|mmc|mms|mt(r|p)|mwbp|mywa|n10[02]|n20[23]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|v)|ng(0|l)|nu(e|t)|nx|om(t|z)|p302|p801|pa(on|ss)|pe(sh|st)|qtek|r380|r600|raks|rim9|ro(a|m)b|rp(on|t)|s55\/|sa(mo|ve)|sh(lm|ow)|si(el)|smar|sq(h|u)|susu|t2(w|g)|t6(0|1|4)|t7(2|9)|tap1|tb(te|v)|tdwa|tel(i|m)|tdg |th(sh|sy)|t(v|v)w|tvas|tves|tx\-9|up(\.b|g1|si)|utst|v400|v750|vtwg|w(c|v)a|wde|wfcn|wp(t|v)|wqsm|wt(c|p)|vk(40|5[0-3]|\-v)|voda|vx(52|67|70|80)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) {
      return true;
    }
    return false;
}

function buildHeaderPrefLocationSection() {
  let prefLocationData = getLocalStorage("prefLocation");
  if(prefLocationData) {
      var $locationDetailsContainer = $('#location-details-container');
          $locationDetailsContainer.empty();
          source = $("#LocationDetailsTemplate").html(),
          template = Handlebars.compile(source);
      //$storeDetailsContainer.append(template1(businessData));
      let prefLocation = {
          prefLocation : prefLocationData
      }
      $locationDetailsContainer.append(template(prefLocation));
  }
}

function saveLocalStorage(property, value) {
    if(window.localStorage) {
      if(typeof value === "string") {
        localStorage.setItem(property, value);
      } else {
        localStorage.setItem(property, JSON.stringify(value));
      }
    } else {
      // need to save to cookie
    }
  }
  
  function removeLocalStorage(property) {
    if(window.localStorage) {
      localStorage.removeItem(property);
    } else {
      // need to remove from cookie
    }
  }
  
  function getLocalStorage(property) {
    let value = "";
    if(window.localStorage) {
      value = localStorage.getItem(property, value);
    } else {
      // need to get from cookie
    }
    return JSON.parse(value);
  }

  function checkAnUpdateFavStar() {
    var userFav = getLocalStorage("userfav");
    if(userFav && userFav.length > 0) {
      $("#fav-star").removeClass('fal').addClass('fas');
    } else {
      $("#fav-star").removeClass('fas').addClass('fal');
    }
  }

  function openNav() {
    document.getElementById("mySidenav").style.width = "100%";
}

/* Set the width of the side navigation to 0 */
function closeNav() {
  $(".accordion.active").removeClass("active");
  $(".panel.sub:visible").hide();
  document.getElementById("mySidenav").style.width = "0";
}

// fav scripts begins
function removeFavAndReload(productData) {
  removeFav(productData);
  loadFav();
}

function removeFav(productData) {
  var userFav = getLocalStorage("userfav");
  if(userFav && userFav !== "") {
    //let obj = userFav.filter(o => o.handle !== productData.handle);
    let obj = userFav.filter(function(o) {
      return o.handle !== productData.handle;
    });
    if(obj && obj.length > 0) {
      userFav = obj;
      saveLocalStorage("userfav", JSON.stringify(userFav));
    } else {
      removeLocalStorage("userfav");
    }
  }
  }
  
  function loadFav() {
    let favProducts = getLocalStorage("userfav");
    if(!favProducts) {
      favProducts = [];
    }
    buildProducts(favProducts);
    checkAnUpdateFavStar();
  }

  function checkIfFav(productHandle) {
    var userFav = getLocalStorage("userfav");
    if(userFav && userFav !== "") {
      //let obj = userFav.filter(o => o.handle === productHandle);
      let obj = userFav.filter(function(o) {
        return o.handle === productHandle;
      });
      if(obj && obj.length != 0) {
        return true;
      }
    }
    return false;
    }
  
  function buildProducts(favProds) {
    var $productContainer = $('#products');
        
        $productContainer.empty();
        var product = {}, 
        data = {}, 
        source = $("#ProductTemplate").html(),
        template = Handlebars.compile(source);
        
    data = {
        product: favProds,
        favAvaiable: favProds.length > 0
    } 
  
    $productContainer.append(template(data));
  }

  function addFav(productData) {
    var userFav = getLocalStorage("userfav");
    if(!userFav || userFav === "") {
      userFav = [];
      userFav.push(productData);
    } else {
      //let obj = userFav.filter(o => o.id === productData.id);
      let obj = userFav.filter(function(o) {
        return o.handle === productData.handle;
      });
      if(!obj || obj.length === 0) {
        userFav.push(productData);
      }
    }
    saveLocalStorage("userfav", JSON.stringify(userFav));
    checkAnUpdateFavStar();
  }

  // fav scripts ends

$(document).ready(function(){
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        var panel = this.nextElementSibling;
        if(panel.style.display === "block" && $(this).data('url')) {
          closeNav();
          window.location.href = $(this).data('url');
        }
        if(!$(this).hasClass('inner')) {
          $(".accordion.active").removeClass("active");
          $(".panel.sub:visible").hide();
        }
        this.classList.toggle("active");
        /* Toggle between hiding and showing the active panel */
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
        });
    }
    
    $(document).on('mouseenter','.cart', function (event) {
        $("#location-info").hide();
        $("#mini-cart").show();
    }).on('mouseleave','#mini-cart',  function(){
        $("#mini-cart").hide();
    });
    
    $(document).on('mouseenter','.locations', function (event) {
      $("#mini-cart").hide(); 
      $("#location-info").show();
    }).on('mouseleave','#location-info',  function(){
       $("#location-info").hide();
    });

    $.fn.serializeObject = function() {
      var o = {};
      var a = this.serializeArray();
      $.each(a, function() {
        if (o[this.name]) {
          if (!o[this.name].push) {
            o[this.name] = [o[this.name]];
          }
          o[this.name].push(this.value || '');
        } else {
          o[this.name] = this.value || '';
        }
      });
      return o;
    };
});
